<template>
  <v-alert :value="showError === undefined ? !!errorMessage : showError" type="error" border="left" :tile="tile" :rounded="rounded">
    <slot>
      {{ errorMessage }}
    </slot>
  </v-alert>
</template>

<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  name: 'ErrorAlert',
  props: {
    showError: {},
    errorMessage: {
      type: String,
    },
    tile: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: String,
      default: undefined,
    },
  },
})
</script>
